import { useState } from 'react';
import { supabase } from '@/lib/supabase/client';

/**
 * Hook to create or find a direct chat between two users
 */
export const useDirectChat = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  /**
   * Find or create a direct chat with another user
   */
  const findOrCreateDirectChat = async (
    currentUserId: string,
    otherUserId: string
  ): Promise<string | null> => {
    try {
      setLoading(true);
      setError(null);

      // Use the database function
      const { data, error: funcError } = await supabase.rpc(
        'find_or_create_direct_chat',
        {
          p_user1_id: currentUserId,
          p_user2_id: otherUserId,
        }
      );

      if (funcError) throw funcError;

      return data as string;
    } catch (err) {
      console.error('Error finding/creating direct chat:', err);
      setError(err instanceof Error ? err.message : 'Failed to create chat');
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    findOrCreateDirectChat,
    loading,
    error,
  };
};

